import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {Router} from '@angular/router';
import {CommonService} from '../../../services/common.service';
import {LogService} from '../../../services/log.service';
import {ReportService} from '../../../services/report.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';

@Component({
    selector: 'app-logs',
    templateUrl: './logs.component.html',
    styleUrls: ['./logs.component.scss']
})
export class LogsComponent implements OnInit {

    //#region Component Members
    pageTitle: any;
    isLoading: boolean;
    logs = new MatTableDataSource<any>();
    affirmationLogs = new MatTableDataSource<any>();
    // columnsToDisplay = ['parentDisplayName', 'childDisplayName', 'formTitle', 'consentDescription', 'consentValue', 'first_sent', 'consentDate', 'unique_token'];
    columnsToDisplay = ['childDisplayName', 'formTitle', 'consentDescription', 'consentValue', 'consentDate', 'unique_token'];
    // columnsToDisplayAffirmations = ['parentDisplayName', 'childDisplayName', 'formTitle', 'activity_description', 'status_id', 'action_date', 'unique_token'];
    columnsToDisplayAffirmations = ['childDisplayName', 'formTitle', 'activity_description', 'status_id', 'action_date', 'unique_token'];
    tableHeight: number;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
    @ViewChild('affirmationPaginator', {static: true}) affirmationPaginator: MatPaginator;

    //#endregion

    constructor(public router: Router,
                public commonService: CommonService,
                private logsService: LogService,
                private reportService: ReportService,
                public toastMessagesService: ToastMessagesService) {
        this.pageTitle = 'Αρχείο κινήσεων και ενεργειών';
        // this.tableHeight = window.innerHeight - 272;
        this.tableHeight = window.innerHeight - 400;
    }

    //#region async functions
    async ngOnInit() {
        this.startLoading();
        await this.getLogs();
        await this.initAffirmationLogs();
        this.setPaginatorTexts(this.paginator);
        this.setPaginatorTexts(this.affirmationPaginator);
        this.logs.paginator = this.paginator;
        this.logs.sort = this.sort;

        this.affirmationLogs.paginator = this.affirmationPaginator;
        this.affirmationLogs.sort = this.sort;
    }

    async getLogs() {
        let consentRecords = [];
        try {
            const request = await this.reportService.getCustomConsentsReport();

            consentRecords = this.formatRecords(request);
            this.logs = new MatTableDataSource<any>(consentRecords);
            // this.consents = new MatTableDataSource<any>(consentRecords);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    async initAffirmationLogs() {
        let consentRecords = [];
        try {
            const request = await this.reportService.getCustomAffirmationsReport();
            consentRecords = this.formatAffirmationRecords(request);
            this.affirmationLogs = new MatTableDataSource<any>(consentRecords);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);

        }
    }

    async navigateToDetails(row: any) {
        const inputConfig = {
            mode: 1,
            id: row.id,
            token: row.unique_token
        };
        await this.router.navigate(['home/log-details'], {queryParams: inputConfig});
    }

    //#endregion

    //#region helper functions
    formatRecords(request: any) {
        const consentRecords = [];
        let position = 1;
        for (const consent of request) {
            for (const question of consent.questions) {
                for (const accepted of question.accepted) {
                    const recordModel = {
                        position,
                        id: consent.id,
                        formTitle: consent.title,
                        reportId: accepted.reportId,
                        consentDescription: question.title,
                        consentValue: 1,
                        childDisplayName: `${accepted.childInfo.firstName} ${accepted.childInfo.lastName}`,
                        childId: accepted.childInfo.id,
                        consentDate: accepted.completed_at,
                        unique_token: consent.unique_id
                    };
                    consentRecords.push(recordModel);
                    position++;
                }

                for (const denied of question.denied) {
                    const recordModel = {
                        position,
                        id: consent.id,
                        formTitle: consent.title,
                        reportId: denied.reportId,
                        consentDescription: question.title,
                        consentValue: 0,
                        childDisplayName: `${denied.childInfo.firstName} ${denied.childInfo.lastName}`,
                        childId: denied.childInfo.id,
                        consentDate: denied.completed_at,
                        unique_token: consent.unique_id
                    };
                    consentRecords.push(recordModel);
                    position++;
                }

                for (const pending of question.pending) {
                    const recordModel = {
                        position,
                        id: consent.id,
                        formTitle: consent.title,
                        reportId: pending.reportId,
                        consentDescription: question.title,
                        consentValue: -1,
                        childDisplayName: `${pending.childInfo.firstName} ${pending.childInfo.lastName}`,
                        childId: pending.childInfo.id,
                        consentDate: '-',
                        unique_token: consent.unique_id
                    };
                    consentRecords.push(recordModel);
                    position++;
                }
            }
        }

        return consentRecords;
    }

    formatAffirmationRecords(request: any) {
        const consentRecords = [];
        let position = 1;
        for (const consent of request) {
            for (const question of consent.questions) {
                for (const accepted of question.accepted) {
                    const recordModel = {
                        position,
                        id: consent.id,
                        formTitle: consent.title,
                        reportId: accepted.reportId,
                        activity_description: question.title,
                        status_id: 1,
                        childDisplayName: `${accepted.childInfo.firstName} ${accepted.childInfo.lastName}`,
                        childId: accepted.childInfo.id,
                        action_date: accepted.completed_at,
                        unique_token: consent.unique_id
                    };
                    consentRecords.push(recordModel);
                    position++;
                }

                for (const denied of question.denied) {
                    const recordModel = {
                        position,
                        id: consent.id,
                        formTitle: consent.title,
                        reportId: denied.reportId,
                        activity_description: question.title,
                        status_id: 0,
                        childDisplayName: `${denied.childInfo.firstName} ${denied.childInfo.lastName}`,
                        childId: denied.childInfo.id,
                        action_date: denied.completed_at,
                        unique_token: consent.unique_id
                    };
                    consentRecords.push(recordModel);
                    position++;
                }

                for (const pending of question.pending) {
                    const recordModel = {
                        position,
                        id: consent.id,
                        formTitle: consent.title,
                        reportId: pending.reportId,
                        activity_description: question.title,
                        status_id: -1,
                        childDisplayName: `${pending.childInfo.firstName} ${pending.childInfo.lastName}`,
                        childId: pending.childInfo.id,
                        action_date: '-',
                        unique_token: consent.unique_id
                    };
                    consentRecords.push(recordModel);
                    position++;
                }
            }
        }

        return consentRecords;
    }

    public setPaginatorTexts(paginator: MatPaginator): MatPaginator {
        paginator._intl.itemsPerPageLabel = 'Εγγραφές Ανά Σελίδα';
        paginator._intl.firstPageLabel = 'Πρώτη Σελίδα';
        paginator._intl.lastPageLabel = 'Τελευταία Σελίδα';
        paginator._intl.nextPageLabel = 'Επόμενη Σελίδα';
        paginator._intl.previousPageLabel = 'Προηγούμενη Σελίδα';

        paginator._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
            if (length === 0 || pageSize === 0) {
                return `0 από ${length}`;
            }

            length = Math.max(length, 0);

            const startIndex = page * pageSize;

            const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

            return `${startIndex + 1} - ${endIndex} από ${length}`;
        };

        return paginator;
    }

    startLoading() {
        this.isLoading = true;
    }

    stopLoading() {
        this.isLoading = false;
    }


    search(value: any) {
        this.logs.filter = value.trim().toLocaleLowerCase();
    }

    searchAffirmations(value: any) {
        this.affirmationLogs.filter = value.trim().toLocaleLowerCase();
    }

//#endregion

    //#region Unused Methods
    async navigateToAffirmationDetails(row) {
        // const inputConfig = {
        //   mode: 2,
        //   id: row.id,
        //   token: row.unique_token
        // };
        // await this.router.navigate(['home/log-details'], {queryParams: inputConfig});
    }

    // async getLogs() {
    //   try {
    //     const logRequest = await this.commonService.getList(`consents/logs?all=true`);
    //     for (const log of logRequest.object) {
    //       log.childDisplayName = `${log.childFirstName} ${log.childLastName}`;
    //       log.parentDisplayName = `${log.parent_first_name} ${log.parent_last_name}`;
    //     }
    //     this.logs = new MatTableDataSource<any>(logRequest.object);
    //   } catch (e) {
    //     this.toastMessagesService.toastErrorMessage(e.message);
    //   }
    // }

    // async initAffirmationLogs() {
    //   try {
    //     const logAffirmationRequest = await this.logsService.getUserAffirmationCollegeLogs();
    //     console.log(logAffirmationRequest);
    //     this.affirmationLogs = new MatTableDataSource<any>(logAffirmationRequest);
    //   } catch (e) {
    //     this.toastMessagesService.toastErrorMessage(e.message);
    //   }
    // }
    //#endregion
}
